<script setup lang="ts">
import { getTranslatedProperty, getCategoryRoute } from "@shopware/helpers";

import { useCachedCmsElementsFromCategoryWithChilds } from "~/components/server/useCachedCmsElementsFromCategoryWithChilds";

const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const categoryId = "01944084030a79019d6e5c9888c6cd6d";
const categoryData =
  await useCachedCmsElementsFromCategoryWithChilds(categoryId);
const subCategories = categoryData[0].children;
</script>
<template>
  <footer>
    <div class="bg-black03 py-3 md:py-2 text-white">
      <div class="container xl:ps-[100px]">
        <ul class="flex flex-wrap gap-y-3 gap-7 text-sm hover_f_menu">
          <li>© Copyright 2025</li>
          <template v-if="subCategories" v-for="nav in subCategories">
            <li>
              <NuxtLink
                role="menuitem"
                :target="nav.linkNewTab ? '_blank' : ''"
                :to="formatLink(getCategoryRoute(nav))"
              >
                {{ getTranslatedProperty(nav, "name") }}
              </NuxtLink>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </footer>
</template>
